<template>
  <div class="invite-stream-page">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad">
      <van-cell v-for="(item, index) in streamList" :key="index">
        <div class="user-item">
          <van-image width="45" height="45" :src="item.avatar" />
          <div class="user-text">
            <div>
              <span>{{item.nickname}}</span>
              <span v-if="item.type==2">开通/续费会员</span>
              <span v-else>完成了任务</span>
            </div>
            <div class="user-time">{{item.created_at | transLocalTime}}</div>
          </div>
          <div class="money">
            +{{item.award}}元
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  List,
  Cell,
  Image,
} from 'vant';
import InviteProxy from '@/proxies/invite';

export default {
  data() {
    return {
      streamList: [],
      finished: false,
      loading: false,
      pageIndex: 1,
      totalRecordCount: 0,
    };
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Cell.name]: Cell,
    [Image.name]: Image,
  },
  watch: {
    userId() {
      this.pageIndex = 1;
      this.getInviteStream();
    },
  },
  computed: {
    userId() {
      return this.$store.state.account.info.id;
    },
  },
  methods: {
    onLoad() {
      this.loading = true;
      setTimeout(() => {
        this.getInviteStream();
      }, 500);
    },
    async getInviteStream() {
      const params = {
        page: this.pageIndex,
        userId: this.userId,
      };
      const res = await InviteProxy.getInviteStream(params);
      this.loading = false;
      if (!res.fail) {
        // 如果是获取第一页就清空整个列表TODO
        if (this.pageIndex === 1) {
          this.streamList = [];
        }
        this.pageIndex += 1;
        this.streamList = this.streamList.concat(res.data.list);
        this.totalRecordCount = res.data.totalCount;
        // 无数据
        if (this.streamList.length === this.totalRecordCount || !res.data.list.length) {
          this.finished = true;
        } else if (this.streamList.length < this.totalRecordCount) {
        // 还有数据
          this.finished = false;
        }
      }
    },
  },
};
</script>

<style lang="less">
  .invite-stream-page {
    .user-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      img {
        border-radius: 5px;
      }
    }
    .money {
      font-size: 16px;
      color: #F56C6C;
    }
    .user-time {
      color: #bbb;
      font-size: 12px;
    }
    .user-text {
      flex-grow: 1;
      margin-left: 10px;
      font-size: 16px;
    }
  }
</style>
